import { observer } from 'mobx-react'
import InfoGatheringCardViewModel from './InfoGatheringCardViewModel'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContentBlock,
  ModalSheetContentTitle,
  ModalSheetFooterButtonGroup,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetContentDescription,
  ModalSheetFooterSection,
  ModalSheetContentIllustration,
} from 'components/ModalSheet'
import React from 'react'
import Button from '../../../../../components/Button'
import { CheckboxInputContainer } from '../../../../../components/inputs'

interface Props {
  vm: InfoGatheringCardViewModel
}
export default observer(function CompleteInfoGatheringDialogModal({
  vm,
}: Props) {
  return (
    <ModalSheet
      showing={vm.completeStepConfirmDialog.showing}
      onRequestClose={vm.completeStepConfirmDialog.close}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_get-started.svg')}
            alt="Let's get started"
          />
          <ModalSheetContentTitle>
            You are about to complete info gathering
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? <br />
            The job will be routed to{' '}
            {vm.requestedPro ? (
              <b data-test={'complete-info-gathering-dialog-requested-pro'}>
                {vm.requestedPro.displayName}
              </b>
            ) : (
              'the next available Pro'
            )}
            .
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        {vm.isAdmin && (
          <ModalSheetFooterSection>
            <CheckboxInputContainer
              model={vm}
              field="completeAsAdmin"
              label="Bypass required items as Admin"
              data-test="complete-info-gathering-dialog-complete-as-admin-input"
            />
          </ModalSheetFooterSection>
        )}
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            dataTest="complete-info-gathering-dialog-close-button"
            type="default"
            onClick={vm.completeStepConfirmDialog.close}
          >
            Close
          </Button>
          <Button
            dataTest="complete-info-gathering-dialog-complete-button"
            type="primary"
            onClick={vm.complete}
            disabled={vm.complete.pending}
          >
            Complete
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
